import dataUtils from "@/businesslogic/utils/dataUtils";

export default function gebaeudeUtils(): any {
  const { isEmpty } = dataUtils();

  const berechneGebaeudetyp = (
    gebaeudesubtyp: string,
    anzahlWohnungen: number,
  ) => {
    if (isEmpty(gebaeudesubtyp)) {
      return "";
    } else {
      switch (gebaeudesubtyp) {
        case "efh":
        case "dhh":
        case "rh":
          return "1";
        case "mfh":
          if (anzahlWohnungen < 2) {
            return "1";
          }
          return anzahlWohnungen > 2 ? "3" : "2";
        default:
          return "";
      }
    }
  };

  const gebaeudeSubTypLabel = (
    gebaeudesubtyp: string,
    anzahlWohnungen: number,
  ) => {
    switch (gebaeudesubtyp) {
      case "efh":
        return "Einfamilienhaus";
      case "dhh":
        return "Doppelhaushälfte";
      case "rh":
        return "Reihenhaus";
      case "mfh":
        if (anzahlWohnungen > 2) {
          return "Mehrfamilienhaus, " + anzahlWohnungen + " Wohneinheiten";
        }
        return "Zweifamilienhaus";
      default:
        return "";
    }
  };

  return { berechneGebaeudetyp, gebaeudeSubTypLabel };
}
